import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthContext } from "../_helper/Auth";
import { useEffect } from "react";
import { SomethingWentWrong } from "../CommonElements/SomthingWentWrong";
import { ClientCache } from "../Pages/ClientCache";

/** Allowed while password_change_required is true (must match app route). */
export const MANDATORY_CHANGE_PASSWORD_PATH = "/app/me/change-password";

const PrivateRoutes = () => {
  const {
    token: login,
    user,
    updateUser,
    isInternelServerError,
    emailVerificationPending,
    passwordChangeRequired,
  } = useAuthContext();
  const location = useLocation();
  const { pathname, search } = location;


  useEffect(() => {
    if (!!login && !user) {
      updateUser();
    }
  }, [user, login]);

  if (!login) {
    return <Navigate to={"/login"} state={{ from: pathname + search }} replace />;
  }

  if (
    passwordChangeRequired &&
    pathname !== MANDATORY_CHANGE_PASSWORD_PATH
  ) {
    return (
      <Navigate to={MANDATORY_CHANGE_PASSWORD_PATH} replace />
    );
  }

  if (emailVerificationPending) {
    return <Navigate to="/verify-email" replace />;
  }

  return isInternelServerError ? (
    <SomethingWentWrong />
  ) : (
    <ClientCache>
      <Outlet />
    </ClientCache>
  );
};

export default PrivateRoutes;
